/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

if (isMobile || isTouchDevice) {
  body.classList.add("is-touch");
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // Store the viewport height in pixels for full-height layout calculations.
  let vh = window.innerHeight;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

let viewWidth = window.innerWidth;

window.addEventListener("resize", () => {
  const newViewWidth = window.innerWidth;
  const widthChanged = newViewWidth !== viewWidth;

  // Mobile browser chrome opening/closing fires height-only resize events while
  // scrolling. Updating --vh during that scroll moves every anchor below the
  // full-height page header. Only respond to real mobile orientation/width
  // changes; retain normal resize behaviour for non-touch devices.
  if (isMobile || isTouchDevice) {
    if (widthChanged) {
      setViewHeight();
    }
  } else {
    setViewHeight();
  }

  viewWidth = newViewWidth;
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa-solid, .fa-regular, .fa-light, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();
/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - location tabs (contact page)
    ========================================================================== */

const locationTabs = document.querySelectorAll(".contact-locations__tab");

const locationTabsInit = function (locationTabs) {
  if (!locationTabs) {
    return;
  }

  locationTabs.forEach(tab =>
    tab.addEventListener("click", function () {
      let tabDepartment = tab.dataset.department;
      if (!tab.classList.contains(".contact-locations__tab--active")) {
        // turn off current active classes
        document.querySelector(".contact-locations__tab--active").classList.remove("contact-locations__tab--active");
        document
          .querySelector(".contact-locations__department--active")
          .classList.remove("contact-locations__department--active");
        // make new tab active
        tab.classList.add("contact-locations__tab--active");
        document
          .querySelector(".contact-locations__department--" + tabDepartment)
          .classList.add("contact-locations__department--active");
        Waypoint.refreshAll();
      }
    })
  );
}; // locationTabsInit();
locationTabsInit(locationTabs);

/*  ==========================================================================
    GENERAL - filters dropdown
    ========================================================================== */

const filters = document.querySelector(".filters");
const filtersDropdown = document.querySelector(".filters__dropdown");
const filtersDropdownBtn = document.querySelector(".filters__dropdownbtn");

const filtersDropdownInit = function (filters, filtersDropdown, filtersDropdownBtn) {
  if (!filters || !filtersDropdown || !filtersDropdownBtn) {
    return;
  }
  filtersDropdownBtn.addEventListener("click", function () {
    filters.classList.toggle("filters--dropdownopen");
  });
}; // filtersDropdownInit();
filtersDropdownInit(filters, filtersDropdown, filtersDropdownBtn);

/*  ==========================================================================
    GENERAL - Proram Application Tile More Info
    ========================================================================== */

const applicationTiles = document.querySelectorAll(".tile--programapplication, .tile--courseapplication");

const applicationTilesInit = function (applicationTiles) {
  if (!applicationTiles) {
    return;
  }

  applicationTiles.forEach(applicationTile => {
    const moreInfo = applicationTile.querySelector(".tile__moreinfo");
    const moreInfoBtn = applicationTile.querySelector(".tile__moreinfobtn");
    if (moreInfoBtn && moreInfo) {
      moreInfoBtn.addEventListener("click", function (e) {
        e.preventDefault();
        moreInfo.classList.toggle("tile__moreinfo--open");
        if (moreInfoBtn.innerHTML === "More info") {
          moreInfoBtn.innerHTML = "Close more info";
        } else {
          moreInfoBtn.innerHTML = "More info";
        }
      });
    }
  });
}; // applicationTilesInit();
applicationTilesInit(applicationTiles);

/*  ==========================================================================
    GENERAL - Event Registration Tile More Info
    ========================================================================== */

const registrationTiles = document.querySelectorAll(".tile--eventregistration");

const registrationTilesIniti = function (registrationTiles) {
  if (!registrationTiles) {
    return;
  }

  registrationTiles.forEach(registrationTile => {
    const moreInfo = registrationTile.querySelector(".tile__moreinfo");
    const moreInfoBtn = registrationTile.querySelector(".tile__moreinfobtn");
    if (moreInfoBtn && moreInfo) {
      moreInfoBtn.addEventListener("click", function (e) {
        e.preventDefault();
        moreInfo.classList.toggle("tile__moreinfo--open");
        if (moreInfoBtn.innerHTML === "More info") {
          moreInfoBtn.innerHTML = "Close more info";
        } else {
          moreInfoBtn.innerHTML = "More info";
        }
      });
    }
  });
}; // registrationTilesIniti();
registrationTilesIniti(registrationTiles);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play-large", "progress", "play", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const syncPersonHash = function (fancybox) {
    const slide = fancybox.getSlide();
    const personHash = slide.triggerEl ? slide.triggerEl.getAttribute("href") : slide.src;

    if (/^#person-\d+$/.test(personHash) && window.location.hash !== personHash) {
      history.replaceState(null, "", personHash);
    }
  };

  const clearPersonHash = function () {
    if (/^#person-\d+$/.test(window.location.hash)) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  };

  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails
    on: {
      "Carousel.ready Carousel.change": syncPersonHash,
      close: clearPersonHash
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);

  const personHash = window.location.hash;
  if (/^#person-\d+$/.test(personHash) && document.querySelector(personHash)) {
    Fancybox.show(
      [
        {
          src: personHash,
          type: "inline"
        }
      ],
      fancyboxOptions
    );
  }
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Accordion & Media
  ========================================================================== */

const setActiveItem = function (module, accordionMediaItems, item) {
  accordionMediaItems.forEach(el => {
    el.classList.remove("active");
    el.querySelector(".item__content__inner").style.height = "0px";
  });
  module.querySelectorAll(".accordion-media__media").forEach(el => {
    el.classList.remove("active");
  });
  let itemNo = item.dataset.id;
  item.classList.add("active");
  let innerHeight = item.querySelector(".item__content__leader").offsetHeight;
  item.querySelector(".item__content__inner").style.height = innerHeight + "px";
  module.querySelector(".accordion-media__media[data-id='" + itemNo + "']").classList.add("active");
};

const accordionMediaInit = function () {
  const accordionMedia = document.querySelectorAll(".module--accordion-media");

  if (!accordionMedia) {
    return;
  }

  accordionMedia.forEach(module => {
    let accordionMediaItems = module.querySelectorAll(".accordion-media__item");

    if (!accordionMediaItems) {
      return;
    }

    accordionMediaItems.forEach(item => {
      item.addEventListener("click", function () {
        setActiveItem(module, accordionMediaItems, this);
      });
    });

    // set first item as active on load
    console.log(accordionMediaItems);
    setActiveItem(module, accordionMediaItems, accordionMediaItems[0]);

    window.addEventListener(
      "resize",
      function (event) {
        setActiveItem(module, accordionMediaItems, module.querySelector(".accordion-media__item.active"));
      },
      true
    );
  });
};
accordionMediaInit();

/*  ==========================================================================
    GENERAL - Gravity Forms “Other” choice text input
  ========================================================================== */

function updateOtherChoicePlaceholders() {
  document.querySelectorAll(".gchoice_other_control").forEach(input => {
    input.placeholder = "Other";

    // Preserve user input after validation errors.
    if (input.value === "Other") {
      input.value = "";
    }
  });
}

document.addEventListener("DOMContentLoaded", updateOtherChoicePlaceholders);

// Handles Gravity Forms AJAX rendering.
document.addEventListener("gform/postRender", updateOtherChoicePlaceholders);

// Compatibility with older Gravity Forms versions.
if (window.jQuery) {
  jQuery(document).on("gform_post_render", updateOtherChoicePlaceholders);
}

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

  const loadmoreBtn = document.querySelector(".paging__loadmore");
  const loadmoreContainer = document.querySelector(".loadmore-container");

  const loadmoreLoadPostsMultiplePages = function (pages) {

    if(pages && pages > 1){

      //Stopping default scroll back to previous position
      history.scrollRestoration = 'manual';

      const currentPage = new URL(window.location);
  
      //Creating an array on page numbers to map it
      var list = [];
      for (var i = 1; i < pages; i++) {
        list.push(i);
      }
  
      // Initialising the array of posts pages
      var postsHTML = [];

      const button = loadmoreBtn;
      const buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

      // Array of ajax calls
      var allAJAX = list.map(function(page){
          const data = {
            action: "loadmore",
            query: php_variables.posts, // that's how we get params from wp_localize_script() function
            page: page
          };
          //Updating the url to mtch the page number
          currentPage.searchParams.set('pagenum', page);
          return $.ajax({
            url: php_variables.ajax_url, // AJAX handler
            data: data,
            type: "POST",
            success: function (data) {
              postsHTML[page] = data;
            }
          });
      });

      // Waiting for all the ajax calls to be finished before proceeding
      Promise.all(allAJAX).then(function() {
        // Update current page variable
        php_variables.current_page = pages;

        button.textContent = buttonText; // set back to previous button text

        // Adding the new tiles to the dom
        list.map(page => {
          if(postsHTML[page]){
              loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
            }
        });

        // Updating the href for the loadmore button
        const nextPage = new URL(window.location);
        nextPage.searchParams.set('pagenum', parseInt(pages) + 1);
        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
          
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // Scrolling the page to the last known position
        if(localStorage.getItem("scrollPosition")) {
          window.scroll({
            top: parseInt(localStorage.getItem("scrollPosition"), 10),
            behavior: "instant"
          });
        }
        
      });
    }
  };
  
  const loadmoreLoadPosts = function (e) {

    e.preventDefault(); // Preventing the a tag from redirecting to the page
    
    const button = this;
    const data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    let buttonText; // create variable to store button text
  
    // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        buttonText = button.textContent; // store current button text
        button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.textContent = buttonText; // set back to previous button text 
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
          
          php_variables.current_page++;

          // Only push state to set the last page number or if there is more pages to load
          const currentPage = new URL(window.location);
          
          if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
            currentPage.searchParams.set('pagenum', php_variables.current_page);
            history.pushState({}, "", currentPage);
          }

          //Updating the loadmore link
          const nextPage = new URL(window.location);
          nextPage.searchParams.set('pagenum', parseInt(php_variables.current_page) + 1);

          button.href = nextPage;
  
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.style.display = "none";
          }
          // Re-init links to make sure linklines on newly loaded content still work
          linksInit();
          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones
          // Re-init effects
          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);
          
        } else {
          button.style.display = "none"; // if no data, remove the button as well
        }
      }
    });
  }; // loadmoreLoadPosts();
  
  const loadmoreInit = function () {
    if (!loadmoreBtn) {
      return;
    }
    /** When adding fitering you will need to move this part into the filtering call */
    // Checking if the page paramenter is set
    const currentPage = new URL(window.location);
    let currentPageNum = currentPage.searchParams.get('pagenum');

    //If there is more than one page to load
    if(currentPageNum && currentPageNum > 1){    
      currentPageNum = parseInt(currentPageNum) > parseInt(php_variables.max_page) ? php_variables.max_page : currentPageNum;
      loadmoreLoadPostsMultiplePages(currentPageNum);
    }
    /** -end- */

    // Saving the scroll position before unload
    window.addEventListener("unload", function(e) {
      var scrollPosition = window.pageYOffset;
      localStorage.setItem("scrollPosition", scrollPosition);
    });
    
    loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
  }; // loadmoreInit();
  
  loadmoreInit();
/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Nav button hover animation 
    ========================================================================== */

let navBtns = document.querySelectorAll(".btn--nav");

const navBtnInit = function (navBtns) {
  if (!navBtns) {
    return;
  }

  navBtns.forEach(function (navBtn) {
    let navBtnAnimDiv = navBtn.querySelector(".btn__anim");
    let navBtnAnim = lottie.loadAnimation({
      container: navBtnAnimDiv,
      path: "https://lottie.host/c09e3a89-3779-4379-bc38-3ebc1a272b6a/XfwQ9fBMrh.json",
      autoplay: false,
      loop: false,
      renderer: "svg",
      rendererSettings: {
        viewBoxOnly: true
      }
    });

    navBtn.addEventListener("mouseenter", e => {
      navBtnAnim.goToAndPlay(0);
    });
  });
};

navBtnInit(navBtns);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const animSpeed = 0.7;

const marqClass = "marquee";
const marqInnerClass = "marquee__wrap";
const marqueeElements = document.querySelectorAll(".marquee");

const marqueeReset = function (el) {
  const wrapElements = el.querySelectorAll("." + marqInnerClass);
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;
  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;
    let orginalTiles = "";
    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");
    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }
    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const tile = el.querySelector(".marquee__tile");
    const textWidth = tile.offsetWidth;
    const numTiles = tiles.length;
    const timesToRepeat = minWidth / textWidth;
    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marqueeResize = function (el) {
  // Check if the marquee is large enought for the space
  marqueeReset(el);

  // Check if element has custom speed or default
  let animation_speed = animSpeed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = animSpeed;
  }

  const wrapElements = el.querySelectorAll("." + marqInnerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marqueeInit = function () {
  if (!marqueeElements) {
    return;
  }
  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marqueeResize(el);
    });
  });
  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;
  marqueeElements.forEach(function (el) {
    const tile = el.querySelector(".marquee__tile");
    const textWidth = tile.offsetWidth;
    const timesToRepeat = minWidth / textWidth;
    const textToRepeat = '<div class="marquee__tile">' + tile.innerHTML + "</div>";
    for (let index = 1; index < timesToRepeat; index++) {
      el.innerHTML += textToRepeat;
    }
    // Wrapping the tiles
    el.innerHTML = "<div class='" + marqInnerClass + "'>" + el.innerHTML + "</div>";
    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);
    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";
    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);
    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });
    // Setup animation times
    marqueeResize(el);
    // Once everything is set up, add "loaded" class
    el.classList.add(marqClass + "--loaded");
  });
};

// Defer loading this code until after page load
marqueeInit();

/*  ==========================================================================
    Pageheader - Scrolling Image
    ========================================================================== */

const scrollingImgInit = function () {
  const scrollingImages = document.querySelectorAll(".pageheader__scrollingimg");

  if (scrollingImages.length > 0) {
    scrollingImages.forEach(function (scrollingImg) {
      function getPercentage() {
        const parentElement = scrollingImg.closest(".pageheader__scrollingarea");
        const rect = parentElement.getBoundingClientRect();
        const areaHeight = rect.height;
        const areaTop = parentElement.offsetTop;
        const scrollTop = window.pageYOffset;

        // Scroll start and end points
        const scrollEndPoint = areaTop + areaHeight + 180;

        const scaleStartSize = 0.6; // needs to match css
        const scaleEndSize = 1;

        // Animate the transform and top positions between the scroll_start_point and scroll_end_point - half of the time the width animates
        if (scrollTop < scrollEndPoint) {
          let scrollPercentage = 1 - scrollTop / scrollEndPoint;
          let scaleScalingSize = (scaleStartSize - scaleEndSize) * scrollPercentage + scaleEndSize;
          scrollingImg.style.transform = "translate(-50%, -50%) scale(" + scaleScalingSize + ")";
        } else {
          scrollingImg.style.transform = "translate(-50%, -50%) scale(" + scaleEndSize + ")";
        }
      }
      getPercentage();
      window.addEventListener("scroll", function () {
        getPercentage();
      });
      window.addEventListener("resize", function () {
        getPercentage();
      });
    });
  }
};

scrollingImgInit();

/*  ==========================================================================
    Section Heading - Text fade in
    ========================================================================== */

const textFadeInInit = function () {
  const textFades = document.querySelectorAll(".text-fade:not(.text-fade--ready)");

  if (textFades.length > 0) {
    textFades.forEach(function (textFade) {
      // setup lettering
      $(textFade).lettering();
      // setup waypoint
      new Waypoint({
        element: textFade,
        handler: function (direction) {
          if (direction === "down") {
            textFade.classList.add("text-fade--ready");
          } else {
            textFade.classList.remove("text-fade--ready");
          }
        },
        offset: "90%"
      });
    });
  }
};

textFadeInInit();

/*  ==========================================================================
    Pinned Scroll List
    ========================================================================== */

const pinnedLists = document.querySelectorAll(".pinned-list");

const pinnedListsInit = function (pinnedLists) {
  if (!pinnedLists) {
    return;
  }

  pinnedLists.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        document.querySelectorAll(".pinned-img__img").forEach(function (item) {
          item.classList.remove("active");
        });
        document.querySelector("." + val.dataset.swap).classList.add("active");
      },
      offset: "30%"
    });
  });
}; // pinnedListsInit();
pinnedListsInit(pinnedLists);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const drag = elem.dataset.drag ? elem.dataset.drag : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-regular fa-arrow-left'></i>", "<i class='fa-regular fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
    }
  });
  document.querySelector(".mobnav__bg").addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
      // Close Department Navs
      if (document.querySelector(".mobnav__departmentnav--open")) {
        document.querySelector(".mobnav__departmentnav--open").classList.remove("mobnav__departmentnav--open");
      }
      document.querySelector("body").classList.remove("departmentnavopen");
    }
  });
  mobnavSetHeight();
}; // mobnavInit()
mobnavInit();

window.addEventListener(
  "resize",
  function (event) {
    mobnavSetHeight();
  },
  true
);

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav__main__link--dropdown");
const mobnavBackLinks = document.querySelectorAll(".mobnav__departmentnav__backlink");
const backgroundBackLinks = document.querySelectorAll(".mobnav__departmentnav__blur");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      if (window.innerWidth < 1000) {
        e.preventDefault();
        const mobnavTargetSection = mobnavLink.closest("li").dataset.dropdown;
        if (mobnavTargetSection) {
          document
            .querySelector(".mobnav__departmentnav--" + mobnavTargetSection)
            .classList.add("mobnav__departmentnav--open");
          document.querySelector("body").classList.add("departmentnavopen");
        }
      }
    });
  });

  if (mobnavBackLinks) {
    mobnavBackLinks.forEach(function (mobnavBackLink) {
      mobnavBackLink.addEventListener("click", function (e) {
        e.preventDefault();
        const mobnavTargetSection = mobnavBackLink.closest(".mobnav__departmentnav");
        if (mobnavTargetSection) {
          mobnavTargetSection.classList.remove("mobnav__departmentnav--open");
          document.querySelector("body").classList.remove("departmentnavopen");
        }
      });
    });
  }

  if (backgroundBackLinks) {
    backgroundBackLinks.forEach(function (backgroundBackLink) {
      backgroundBackLink.addEventListener("click", function (e) {
        e.preventDefault();
        const mobnavTargetSection = backgroundBackLink.closest(".mobnav__departmentnav");
        if (mobnavTargetSection) {
          mobnavTargetSection.classList.remove("mobnav__departmentnav--open");
          document.querySelector("body").classList.remove("departmentnavopen");
        }
      });
    });
  }
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Desktop / Sitenav Dropdowns
	========================================================================== */

const dropdown = document.querySelector(".siteheader__dropdown");
const dropdownLinks = document.querySelectorAll(".sitenav__item--dropdown");
const dropdownNavs = document.querySelectorAll(".siteheader__dropdown__nav");
const dropdownOpenClass = "dropdownopen";
const dropdownActiveClass = "siteheader__dropdown__nav--active";
const dropdownLinkActiveClass = "sitenav__item--dropdown--active";
let dropdownHeight = 0;

const dropdownSetHeight = function () {
  dropdown.querySelector(".siteheader__dropdown__inner").style.height = `0px`;
  dropdownHeight = 0;
  dropdownNavs.forEach(function (dropdownNav) {
    dropdownHeight = dropdownNav.offsetHeight > dropdownHeight ? dropdownNav.offsetHeight : dropdownHeight;
  });
  dropdown.querySelector(".siteheader__dropdown__inner").style.height = `${dropdownHeight}px`;
}; // dropdownSetHeight()

const closeDropdown = function () {
  body.classList.remove(dropdownOpenClass);
  // remove active class from other navs
  dropdownNavs.forEach(function (dropdownNav) {
    dropdownNav.classList.remove(dropdownActiveClass);
  });
  // remove active class from other dropdown links
  dropdownLinks.forEach(function (dropdownLink) {
    dropdownLink.classList.remove(dropdownLinkActiveClass);
  });
};

const dropdownInit = function () {
  // Open sitenav links hover show the correct dropdown
  dropdownLinks.forEach(function (dropdownLink) {
    let dropdownType = dropdownLink.dataset.dropdown;
    if (dropdownType) {
      dropdownLink.addEventListener("mouseover", function (e) {
        e.preventDefault();
        body.classList.add(dropdownOpenClass);
        // remove active class from other navs
        dropdownNavs.forEach(function (dropdownNav) {
          dropdownNav.classList.remove(dropdownActiveClass);
        });
        // remove active class from other dropdown links
        dropdownLinks.forEach(function (dropdownLink) {
          dropdownLink.classList.remove(dropdownLinkActiveClass);
        });
        // add active class to this dropdown type
        document.querySelector(".siteheader__dropdown__nav--" + dropdownType).classList.add(dropdownActiveClass);
        // add active class to this dropdown link
        dropdownLink.classList.add(dropdownLinkActiveClass);
      });
    }
  });
  dropdown.addEventListener("mouseleave", function (e) {
    e.preventDefault();
    closeDropdown();
  });
  document.querySelector(".dropdown-blur").addEventListener("click", function (e) {
    e.preventDefault();
    closeDropdown();
  });
  dropdownSetHeight();
}; // dropdownInit()
dropdownInit();

window.addEventListener(
  "resize",
  function (event) {
    dropdownSetHeight();
  },
  true
);

/*  ==========================================================================
	NAVIGATION - Subnav
	========================================================================== */

const subnav = document.querySelector(".subnav");
const subnavInit = function (subnav) {
  if (!subnav) {
    return;
  }

  // Add pinned class when sticky
  const observer = new IntersectionObserver(
    ([e]) => document.querySelector("body").classList.toggle("subnav-is-pinned", e.intersectionRatio < 1),
    {
      threshold: [1]
    }
  );
  observer.observe(subnav);

  // Open subnav on mobile
  subnav.querySelector(".subnav__title").addEventListener("click", function (e) {
    if (window.innerWidth < 1000) {
      e.preventDefault();
      subnav.classList.toggle("subnav--open");
    }
  });
};

subnavInit(subnav);

/*  ==========================================================================
	NAVIGATION - pagenav / jump to
	========================================================================== */

// Cache selectors
const pagenav = document.querySelector(".pagenav");
if (pagenav) {
  let pagenavHeight = pagenav.offsetHeight + 15;
  // All list items
  const menuItems = pagenav.querySelectorAll(".pagenav__link");

  // Anchors corresponding to menu items
  const scrollItems = document.querySelectorAll(".module--anchor:not(.module--anchor--ignore)");

  const updateActivePagenavLink = function () {
    if (!pagenavHeight) {
      return;
    }
    // Get container scroll position
    let fromTop = window.pageYOffset + pagenavHeight;

    // Get id of current scroll item
    let cur;
    for (var i = 0; i < scrollItems.length; i++) {
      if (scrollItems[i].offsetTop < fromTop) {
        cur = scrollItems[i];
      }
    }

    // Get the id of the current element
    if (cur) {
      let id = cur.id;
      // Set/remove active class
      menuItems.forEach(function (menuItem) {
        menuItem.classList.remove("active");
      });
      document.querySelector(".pagenav__link[href='#" + id + "']").classList.add("active");
    }
  };

  window.addEventListener("scroll", updateActivePagenavLink);
}

// JS fallback as we were having issues on IOS Safari
document.querySelectorAll('a[href^="#"]:not([data-fancybox])').forEach(link => {
  link.addEventListener("click", event => {
    const id = link.getAttribute("href");

    if (!id || id === "#") {
      return;
    }

    const target = document.querySelector(id);

    if (!target) {
      return;
    }

    event.preventDefault();

    const header = document.querySelector(".subnav");
    const offset = header ? header.getBoundingClientRect().height : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: "auto"
    });

    history.replaceState(null, "", id);
  });
});

/*  ==========================================================================
	NAVIGATION - school fees nav (for school fees template)
	========================================================================== */

const schoolfeesnav = document.querySelector(".schoolfees__nav");
if (schoolfeesnav) {
  let schoolfeesnavHeight = schoolfeesnav.offsetHeight + 15;
  // All list items
  const menuItems = schoolfeesnav.querySelectorAll("a");

  // Anchors corresponding to menu items
  const scrollItems = document.querySelectorAll(".schoolfees__school__anchor");

  const updateActiveSchoolfessnavLink = function () {
    if (!schoolfeesnavHeight) {
      return;
    }
    // Get container scroll position
    let fromTop = window.pageYOffset + schoolfeesnavHeight;

    // Get id of current scroll item
    let cur;
    for (var i = 0; i < scrollItems.length; i++) {
      if (scrollItems[i].offsetTop < fromTop) {
        cur = scrollItems[i];
      }
    }

    // Get the id of the current element
    if (cur) {
      let id = cur.id;
      // Set/remove active class
      menuItems.forEach(function (menuItem) {
        menuItem.classList.remove("active");
      });
      document.querySelector(".schoolfees__nav a[href='#" + id + "']").classList.add("active");
    }
  };

  window.addEventListener("scroll", updateActiveSchoolfessnavLink);
}

/*  ==========================================================================
	NAVIGATION - school menus nav (for school menus template)
	========================================================================== */

const schoolmenusnav = document.querySelector(".schoolmenus__nav");
if (schoolmenusnav) {
  let schoolmenusnavHeight = schoolmenusnav.offsetHeight + 15;
  // All list items
  const menuItems = schoolmenusnav.querySelectorAll("a");

  // Anchors corresponding to menu items
  const scrollItems = document.querySelectorAll(".schoolmenus__school__anchor");

  const updateActiveSchoolmenusnavLink = function () {
    if (!schoolmenusnavHeight) {
      return;
    }
    // Get container scroll position
    let fromTop = window.pageYOffset + schoolmenusnavHeight;

    // Get id of current scroll item
    let cur;
    for (var i = 0; i < scrollItems.length; i++) {
      if (scrollItems[i].offsetTop < fromTop) {
        cur = scrollItems[i];
      }
    }

    // Get the id of the current element
    if (cur) {
      let id = cur.id;
      // Set/remove active class
      menuItems.forEach(function (menuItem) {
        menuItem.classList.remove("active");
      });
      document.querySelector(".schoolmenus__nav a[href='#" + id + "']").classList.add("active");
    }
  };

  window.addEventListener("scroll", updateActiveSchoolmenusnavLink);
}
